/**
 * @voltxampere/presets — Digital NOT (inverter) gate demo (Sprint 50-5)
 *
 * Single-input inverter (logical NOT). Input HIGH → output LOW;
 * input LOW → output HIGH. Common building block in clock signal
 * conditioning, edge detectors, and logic delay chains.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { makeCircuit, makeNet, makeComponent } from "../_builders.js";
export const digitalNotGate = {
    id: "digital-not-gate",
    name: { tr: "Dijital DEĞİL Kapısı (Inverter)", en: "Digital NOT Gate (Inverter)" },
    category: "digital",
    difficulty: 1,
    description: {
        tr: "Tek girişli inverter. Giriş HIGH ise çıkış LOW (0V); giriş LOW ise çıkış HIGH.",
        en: "Single-input inverter. HIGH input → LOW output; LOW input → HIGH output.",
    },
    circuit: makeCircuit({
        slot: 1,
        name: "Digital NOT Gate",
        description: "Single-input inverter with HIGH input",
        nets: [
            makeNet({ name: "gnd", isGround: true }),
            makeNet({ name: "in1" }),
            makeNet({ name: "out" }),
        ],
        components: [
            makeComponent({
                id: "V_IN",
                type: "voltage-source",
                params: { voltage: 5 },
                terminals: { pos: "net_in1", neg: "net_gnd" },
                label: "V_IN",
                position: { x: -160, y: 0 },
                rotation: 0,
            }),
            makeComponent({
                id: "U1",
                type: "digital-gate",
                params: { gateFunction: "NOT", vHigh: 5, vLow: 0, threshold: 2.5 },
                terminals: { in1: "net_in1", out: "net_out" },
                label: "U1",
                position: { x: 0, y: 0 },
                rotation: 0,
            }),
            makeComponent({
                id: "GND1",
                type: "ground",
                params: {},
                terminals: { p: "net_gnd" },
                position: { x: -160, y: 80 },
                rotation: 0,
            }),
        ],
        wires: [],
    }),
    expectedValues: [
        {
            node: "out",
            analysis: "dc",
            value: 0,
            tolerance: 0.001,
            unit: "V",
        },
    ],
    learningGoals: [
        {
            tr: "DEĞİL kapısı tek girişli, çıkış girişin tam tersi.",
            en: "NOT gate is single-input; output is the input's complement.",
        },
        {
            tr: "Inverter zinciri ile saat sinyali geciktirme.",
            en: "Inverter chain delays clock edges.",
        },
    ],
    references: ["Sedra/Smith, Microelectronic Circuits, Ch. 14"],
};
//# sourceMappingURL=digital-not-gate.js.map